export const LOADING_STATES = {
  NEUTRAL: 0,
  LOADING: 1,
  SUCCESS: 2,
  ERROR: 3,
  TO_NEUTRAL: 4
};
